import { FormControl, InputAdornment, TextField } from "@mui/material";
import React from "react";

const CustomTextField = (props) => {
	const {
		label,
		placeholderValue,
		value,
		type="text",
		handleInputChange,
        EndAdornmentComponent,
		maxLength = 500,
		error,
		className = ''
	} = props;
	return (
		<FormControl fullWidth>
			<TextField
			    className={className}
				autoComplete="off"
				id="searchContact"
				variant="outlined"
				label={label}
				type={type}
				error={error}
				onChange={handleInputChange}
				value={value}
				InputLabelProps={{
					shrink: true,
					style: {
						fontFamily: "Figtree-Regular",
						fontSize: "14px",
						fontWeight: "bold",
						color: "#B2B4C5",
                        padding: "0 0.25rem",
                        backgroundColor: "#fff",
					},
				}}
				InputProps={{
					sx: { fontFamily: "Figtree-Regular", fontSize: "13px", color: "#B2B4C5" },
					placeholder: placeholderValue,
					endAdornment: EndAdornmentComponent && EndAdornmentComponent,
					maxLength:maxLength
				}}
				sx={{
					"& .MuiOutlinedInput-root": {
						borderRadius: "10px",
						"& .MuiOutlinedInput-notchedOutline": {
							borderColor: error ? "#FE3A3A" : "#E7E7FF",
							borderWidth: "1px", // Ensure border width is consistent
						},
						"&:hover .MuiOutlinedInput-notchedOutline": {
							borderColor: error ? "#FE3A3A" : "#E7E7FF",
							borderWidth: "1px", // Ensure border width is consistent on hover
						},
						"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
							borderColor: "#E7E7FF",
							borderWidth: "1px", // Ensure border width is consistent on focus
						},
					},
					marginBottom: "10px",
				}}
			/>
		</FormControl>
	);
};

export default CustomTextField;
